import React, { Component } from 'react';
import { View, Button, Scene, AppHeader, Text, TextArea, Checkbox, RadioGroup } from 'core';
import * as actions from 'actions';
import { css, theme, GROUP_ROLES, REPORT_TYPE } from 'constants';
import { lang } from 'lang';

const styles = css({
  main: {
    padding: 20,
    flex: 1
  },
  circle: {
    height: 22,
    width: 22,
    borderRadius: 11,
    borderColor: theme.primary_color,
    borderWidth: 1,
    marginRight: 10
  },
  row: {
    flexDirection: 'row',
    marginTop: 10
  },
  checkbox: {
    marginRight: 9
  }
});

class Modal extends Component {
  state = {};

  renderReport = () => {
    const { block_box, report_box } = this.state;
    const options = [
      { text: lang.SEXUAL_CONTENT, value: REPORT_TYPE.SEXUAL_CONTENT },
      { text: lang.VIOLENT_CONTENT, value: REPORT_TYPE.VIOLENT_CONTENT },
      { text: lang.SPAM, value: REPORT_TYPE.SPAM }
    ];
    return (
      <View>
        {block_box ? (
          <Checkbox
            onValueChange={() => {
              this.setState({ report_box: !report_box, report_type: null });
            }}
            value={report_box}
            title={lang.REPORT_MEMBER}
            style={{ marginTop: 5 }}
          />
        ) : null}
        {report_box ? (
          <RadioGroup
            onValueChange={(value, index, text) => {
              this.setState({ report_type: value });
            }}
            options={options}
            style={{ marginLeft: 15, marginTop: 5 }}
          />
        ) : null}
      </View>
    );
  };

  render() {
    const { conv_id, member_id, status } = this.props;
    const { reason, block_box, report_type } = this.state;
    return (
      <Scene>
        <AppHeader title={lang.REMOVE_MEMBER} close />
        <View style={styles.main}>
          <Text>
            {lang.REASON} <Text style={{ color: theme.gray_color_lighten(0.4), fontSize: theme.font_sm }}>{lang.OPTIONAL}</Text>
          </Text>
          <TextArea onChangeText={reason => this.setState({ reason })} min_row={3} value={reason} style={{ marginTop: 5, marginBottom: 10 }} />
          <Checkbox
            onValueChange={() => {
              this.setState({
                block_box: !block_box,
                report_type: null,
                report_box: false
              });
            }}
            value={block_box}
            title={lang.BLOCK_FROM_GROUP}
            style={{ marginBottom: 5 }}
          />
          {this.renderReport()}
        </View>
        <Button
          title={lang.DONE}
          onPress={() =>
            actions.sendRemoveMember({
              conv_id,
              member_id,
              reason,
              role: block_box ? GROUP_ROLES.BLOCKED : GROUP_ROLES.REMOVED,
              report: report_type
            })
          }
          style={{ alignSelf: 'center', marginBottom: 20 }}
          status={status}
          onSuccess={() => {
            actions.clickCloseModal();
          }}
        />
      </Scene>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modals/remove_member.js